var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7028 18.3327L19.1195 11.7493C18.8159 11.435 18.6479 11.014 18.6517 10.577C18.6555 10.14 18.8308 9.72197 19.1398 9.41296C19.4488 9.10395 19.8668 8.92867 20.3038 8.92487C20.7408 8.92107 21.1618 9.08906 21.4761 9.39266L30.9045 18.821C31.0598 18.9754 31.183 19.159 31.2671 19.3612C31.3512 19.5635 31.3945 19.7803 31.3945 19.9993C31.3945 20.2183 31.3512 20.4352 31.2671 20.6374C31.183 20.8396 31.0598 21.0232 30.9045 21.1777L21.4761 30.606C21.1604 30.9021 20.7418 31.0637 20.309 31.0567C19.8762 31.0497 19.4631 30.8745 19.1572 30.5683C18.8512 30.2621 18.6763 29.8489 18.6696 29.4161C18.6629 28.9833 18.8248 28.5649 19.1211 28.2493L25.7045 21.666H9.72781C9.28578 21.666 8.86186 21.4904 8.5493 21.1778C8.23673 20.8653 8.06114 20.4414 8.06114 19.9993C8.06114 19.5573 8.23673 19.1334 8.5493 18.8208C8.86186 18.5083 9.28578 18.3327 9.72781 18.3327H25.7028Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c1d3b4c0216d77264c1a839549f3b661.svg";
export { ForwardRef as ReactComponent };